"use client"

import { VisaHero } from "@/features/client/sections/Visa/VHero"
import { VisaApplication } from "@/features/client/sections/Visa/VisaForm"
import { ContactInfo } from "@/features/client/sections/Visa/VisaContactInfo"

export default function Visa() {
  return (
    <main className="min-h-screen bg-gray-50">
      <VisaHero />
      <div className="relative">
        <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-orange-500 to-transparent opacity-50"></div>
      </div>
      <VisaApplication />
      <div className="relative">
        <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-orange-500 to-transparent opacity-50"></div>
      </div>
      <ContactInfo />
    </main>
  )
}
